module.exports = __webpack_public_path__ + "img/header-weddingRingsWaveDesign@2x.a30115b.jpg";